import React from 'react';
import styled from 'styled-components';

export const ScheduleTimeCell = ({ value, isTemporaryClosed }: any) => (
  <StyledCell $highlightClosed={isTemporaryClosed}>{value || 'CLOSED'}</StyledCell>
);

const StyledCell = styled.div<{ $highlightClosed?: boolean }>`
  background-color: ${({ $highlightClosed }) => ($highlightClosed ? '#FFEAEA' : '#ffffff')};

  border: 1px solid ${({ $highlightClosed }) => ($highlightClosed ? '#FF4D4F' : '#f6f6f6')};

  color: ${({ $highlightClosed }) => ($highlightClosed ? '#FF4D4F' : '#000')};

  border-radius: 24px;
  height: 20px;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: ${({ $highlightClosed }) => ($highlightClosed ? 600 : 400)};
`;
